import React from 'react';

const OverwriteModal = ({
  uploadedFileName,
  onCancel,
  onSaveRecordOnly,
  onFullRedistribute,
}) => (
  <div
    className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="overwrite-modal-title"
  >
    <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6 space-y-4">
      <h2 id="overwrite-modal-title" className="text-lg font-semibold text-gray-900">
        Bu dosya için tevzi zaten kayıtlı
      </h2>
      <p className="text-sm text-gray-600 leading-relaxed">
        &quot;{uploadedFileName}&quot; adlı kayıt üzerine yazılacak. Genel hakim listesine (puan ve dosya
        sayısı) nasıl yansıtacağınızı seçin:
      </p>
      <ul className="text-sm text-gray-600 list-disc pl-5 space-y-2">
        <li>
          <span className="font-medium text-gray-800">Yalnızca tevzi kaydı:</span>{' '}
          Ekrandaki dağıtımı (manuel taşıdığınız dosyalar dahil) klasöre kaydeder; hakim listesindeki toplam
          puan ve dosya sayısı bu seçenekle değişmez.
        </li>
        <li>
          <span className="font-medium text-gray-800">Kayıt ve puanları yeniden hesapla:</span>{' '}
          Bu kaydın daha önce genel listeye işlediği puan ve dosya sayısı artışını geri alır (mükerrer
          etki önlenir), ekrandaki atamalarınız aynı kalır ve buna göre puanlar yeniden hesaplanır; güncel
          kayıt ve hakim listesi kaydedilir.
        </li>
      </ul>
      <div className="flex flex-col sm:flex-row gap-2 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
        >
          İptal
        </button>
        <button
          type="button"
          onClick={onSaveRecordOnly}
          className="flex-1 px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-white font-medium"
        >
          Yalnızca tevzi kaydı
        </button>
        <button
          type="button"
          onClick={onFullRedistribute}
          className="flex-1 px-4 py-2 rounded bg-indigo-600 hover:bg-indigo-700 text-white font-medium"
        >
          Kayıt ve puanları yeniden hesapla
        </button>
      </div>
    </div>
  </div>
);

export default OverwriteModal;
